<template>
  <div
    :id="fieldId"
    :class="'date-offset-wrapper date-offset-input ' + fieldClass"
    :data-test="dataTest"
  >
    <template v-for="childElement in getChildFields">
      <entity-form-field
        :key="childElement?.field_name"
        :field-data="childElement"
        :parent-value="fieldValue?.[childElement?.field_name]"
        @update-form-data="pickUpdateMethod($event)"
        :bundle="bundle"
        :entity-type="entityType"
      />
    </template>
    <div v-if="!fieldData?.settings?.ignore_basedate">
      <!--  Note: base_date_field and base_date will be added here in future development.
           After RAFT-6470 is resolved.  -->
    </div>
  </div>
</template>

<script>
export default {
  name: "DateOffsetField",
  components: {
    EntityFormField: () => import("../EntityFormField.vue"),
  },
  data() {
    return {
      selected: {
        offset: this.fieldData?.field_value?.offset ?? false,
        offset_qty: this.fieldData?.field_value?.offset_qty ?? null,
        offset_unit: this.fieldData?.field_value?.offset_unit ?? null,
        offset_direction: this.fieldData?.field_value?.offset_direction ?? null,
        base_date_field: this.fieldData?.field_value?.base_date_field ?? null,
        base_date: this.fieldData?.field_value?.base_date ?? null,
      },
    };
  },
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    fieldClass: {
      type: String,
      required: true,
    },
    fieldData: {
      type: Object,
      required: true,
    },
    fieldValue: {
      type: Object,
      default: function () {
        return {
          offset: false,
          offset_qty: null,
          offset_unit: "",
          offset_direction: null,
          base_date_field: null,
          base_date: null,
        };
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    dataTest: {
      type: String,
      default: "",
    },
    bundle: {
      type: String,
      required: true,
    },
    entityType: {
      type: String,
      required: true,
    },
  },
  computed: {
    getChildFields() {
      let children = [];
      const childFieldSettings = this.fieldData?.settings?.child_fields;
      if (childFieldSettings) {
        Object.entries(childFieldSettings).forEach(([key, value]) => {
          children.push({
            ...value,
          });
        });
      }
      // Note: The following will need to be adjusted when we update this for requirements to use base date.
      // Currently, we're only using it in vue.js for message scheduling where that is not applicable and offset is
      // always true, even if it's a 0 offset. Requirements can use the base date fields, but do not in vue.js yet.
      children = children.filter(
        (field) =>
          field.field_name !== "offset" &&
          field.field_name !== "base_date_field" &&
          field.field_name !== "base_date",
      );
      return children;
    },
  },
  mounted() {
    this.resetData();
  },
  methods: {
    updateOffsetQty(value) {
      this.selected.offset = true;
      this.selected.offset_qty = value;
    },
    updateOffsetUnit(value) {
      this.selected.offset = true;
      this.selected.offset_unit = value;
    },
    updateOffsetDirection(value) {
      this.selected.offset = true;
      this.selected.offset_direction = value;
    },
    resetData() {
      this.selected = {
        offset: false,
        offset_qty: null,
        offset_unit: "",
        offset_direction: null,
        base_date_field: null,
        base_date: null,
      };
      if (!this.fieldValue) {
        return;
      }
      if (this.fieldValue.hasOwnProperty("offset") && !this.fieldValue.offset) {
        return;
      }
      this.selected.offset = true;
      this.selected.offset_qty = this.fieldValue?.offset_qty || null;
      this.selected.offset_unit = this.fieldValue?.offset_unit || "";
      this.selected.offset_direction =
        this.fieldValue?.offset_direction || null;
      // Add following after RAFT-6470.
      // this.selected.base_date_field = this.fieldValue?.base_date_field;
      // this.selected.base_date = this.fieldValue?.base_date;
    },
    pickUpdateMethod(value) {
      switch (value.field_name) {
        case "offset_qty":
          this.updateOffsetQty(value.field_value);
          break;
        case "offset_unit":
          this.updateOffsetUnit(value.field_value);
          break;
        case "offset_direction":
          this.updateOffsetDirection(value.field_value);
          break;
        default:
      }
      this.$emit("change", this.selected);
    },
  },
  watch: {
    fieldValue() {
      this.resetData();
    },
  },
};
</script>

<style scoped>
.date-offset-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.date-offset-wrapper .form-item {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
